import Vue from "vue";
import Vuex from "vuex";

import contactGroup from "../services/contactGroups.js";
Vue.use(Vuex);

const breadcrumb = {
  namespaced: true,
  state: () => ({
    items: [], // [{ label, to? }]
  }),
  mutations: {
    SET(state, items) { state.items = Array.isArray(items) ? items : []; },
    CLEAR(state) { state.items = []; },
  },
  getters: {
    items: (s) => s.items,
  },
  actions: {
    async updateForRoute({ commit }, { route, siteId, siteName, getPageTitle }) {
      const base = [
        { label: 'Sites', to: '/sites' },
        { label: siteName || '…', to: `/site/${siteId}/pages` },
      ];

      if (route.name === 'Site Pages') {
        commit('SET', [
          ...base,
          { label: 'Site Pages', to: `/site/${siteId}/pages` },
        ]);
        return;
      }

      if (route.name === 'Site Page New') {
        commit('SET', [
          ...base,
          { label: 'Site Pages', to: `/site/${siteId}/pages` },
          { label: 'New Page' },
        ]);
        return;
      }

      if (route.name === 'Site Page') {
        const title = getPageTitle ? await getPageTitle(route.params.pageid) : null;
        commit('SET', [
          ...base,
          { label: 'Site Pages', to: `/site/${siteId}/pages` },
          { label: title || '…' },
        ]);
        return;
      }
      commit('SET', base);
    },
  },
};

export const store = new Vuex.Store({
  state: {
    flavor: "berry",
    contactGroupsBasic: null,
  },
  mutations: {
    changeFlavor(state, flavor) {
      state.flavor = flavor;
    },
    updateContactGroupBasic(state, contactGroupUpdated) {
      alert("yay");
    }
  },
  getters: {
    flavor: (state) => state.flavor,
  },
  actions: {
    async saveContactGroup({ commit }) {
      const user = await contactGroup.save();
      commit("updateContactGroupBasic", response.data);
    },
  },
  modules: {
    breadcrumb,
  },
});
